<template>
    <section container>
        <Banner/>

        <Summary/>

        <Features/>

        <section content padding v-if="product.support">
            <div class="d-block mlr-xl p-lg bd-1 radius-xl shadow-large">
                <Row type="flex" justify="center" align="middle">
                    <Col :xs="24" :sm="24" :md="18" :lg="18">
                        <h1>{{ $common.config.lang === 'cn' ? '产品支持文档' : 'Product support documents' }}</h1>
                        <h3>{{ $common.config.lang === 'cn' ? '有一个详尽的文档部分，以及使用下面的按钮与我们联系的简便方法' : 'There is a detailed documentation section and an easy way to contact us using the buttons below' }}</h3>
                    </Col>
                    <Col :xs="24" :sm="24" :md="2" :lg="3">&nbsp;</Col>
                    <Col :xs="24" :sm="24" :md="4" :lg="3">
                        <Button long ghost shape="circle" size="large" type="primary" @click="toSupport">{{ $common.config.lang === 'cn' ? '文件资料' : 'View Files' }}</Button>
                    </Col>
                </Row>
            </div>
        </section>

        <Prices/>

        <Story/>

        <Partner/>

        <Contact/>
    </section>
</template>

<script type="text/javascript">
    import Banner from "../../components/Banner";
    import Summary from "../../components/Summary";
    import Features from "../../components/Features";
    import Prices from "../../components/Prices";
    import Story from "../../components/Story";
    import Partner from "../../components/Partner";
    import Contact from "../../components/Contact";

    export default {
        components: {
            Banner, Summary, Features, Prices, Story, Partner, Contact,
        },
        data() {
            return {
                product: {},
            }
        },
        async beforeDestroy() {
            await this.$bus.off('initProduct');
        },
        async created(){
            await this.getProduct();
        },
        async mounted() {
            this.$bus.on('initProduct', async (data) => {
                if (!data) return;
                await this.getProduct();
            });
        },
        methods: {
            async getProduct(){
                debugger
                let res = await this.$api.getHttp('/product/detail?id=' + this.$route.query.id + '&lang=' + this.$common.config.lang);
                console.log('this.getProduct---------->', res);
                this.product = {} = res.data.data;
                this.$bus.emit('initBanner', this.product, true);
                this.$bus.emit('initSummary', this.product, true);
                this.$bus.emit('initFeatures', this.product, true);
                this.$bus.emit('initPrice', this.product, true);
                this.$bus.emit('initStory', this.product, true);
            },
            toSupport(){
                this.$router.push({
                    path: '/support',
                    query: {
                        id: this.$route.query.id,
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/product/index.vue